export default __webpack_public_path__ + "static/media/Path 108.24b86cea.svg";